import { render, staticRenderFns } from "./ApplicantTypeComplete.vue?vue&type=template&id=59bf0e3a&scoped=true&"
import script from "./ApplicantTypeComplete.vue?vue&type=script&lang=js&"
export * from "./ApplicantTypeComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf0e3a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bf0e3a')) {
      api.createRecord('59bf0e3a', component.options)
    } else {
      api.reload('59bf0e3a', component.options)
    }
    module.hot.accept("./ApplicantTypeComplete.vue?vue&type=template&id=59bf0e3a&scoped=true&", function () {
      api.rerender('59bf0e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/ApplicantTypeComplete.vue"
export default component.exports